import { PushNotifications, Token } from '@capacitor/push-notifications';
import { IS_MOBILE_APP } from 'const';

export default function usePushNotification(): {
  onPushNotificationRegistered: (callback: (token: string) => void) => void;
  enablePushNotification: () => void;
  isPushNotificationEnabled: () => Promise<boolean>;
} {
  return {
    isPushNotificationEnabled: async () => {
      if (!IS_MOBILE_APP) return false;

      const permissionStatus = await PushNotifications.checkPermissions();
      return permissionStatus.receive === 'granted';
    },
    onPushNotificationRegistered: (callback: (token: string) => void) => {
      if (!IS_MOBILE_APP) return;

      // On success, we should be able to receive notifications
      PushNotifications.addListener('registration', ({ value: token }: Token) => {
        callback(token);

        // TODO send this as a log to the BE
        //alert('Push registration success, token: ' + token);
      });
    },
    enablePushNotification: () => {
      if (!IS_MOBILE_APP) return;

      // Request permission to use push notifications
      // iOS will prompt user and return if they granted permission or not
      // Android will just grant without prompting
      PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        } else {
          console.warn('PushNotifications status', result);
        }
      });

      // Some issue with our setup and push will not work
      //eslint-disable-next-line
      // PushNotifications.addListener('registrationError', (error: any) => {
      //   // TODO push those errors to the API Log
      //   // alert('Error on registration: ' + JSON.stringify(error));
      // });

      // We are using https://capacitorjs.com/docs/apis/push-notifications#push-notifications-appearance-in-foreground
      // so this is not needed

      // Show us the notification payload if the app is open on our device
      // PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
      //   alert(`${notification.title}: ${notification.body}`);
      //   // alert('Push received: ' + JSON.stringify(notification));
      // });

      // Method called when tapping on a notification
      // PushNotifications.addListener('pushNotificationActionPerformed', () => {
      //   // notification: ActionPerformed
      //   // TODO refresh the app when we click on the push notification
      //   // alert('Push action performed: ' + JSON.stringify(notification));
      // });
    },
  };
}
